<template>
  <el-card shadow="never">
    <el-form
      ref="form"
      :model="form"
      label-width="180px"
      inline
      style="margin-top: 28px"
    >
      <el-form-item label="Parent Company #">
        <el-select
          v-model="form.parentId"
          style="width: 300px"
          filterable
          remote
          :remote-method="name => remoteMethod(name)"
          :loading="loading"
          placeholder="search"
        >
          <el-option
            v-for="item in parentCompanyList"
            :value="item.companyId"
            :label="item.companyName"
            :key="item.companyId"
          />
        </el-select>
      </el-form-item>
      <el-form-item style="margin-left: 40px">
        <customize-button type="primary" @click="handleClickSearchBtn">
          Search
        </customize-button>
      </el-form-item>
    </el-form>
    <template v-if="Object.keys(detail).length">
      <el-divider />
      <el-row :gutter="40">
        <el-col :md="12" :lg="8" :xl="6">
          Parent Company #:
          <span class="value">{{ detail.parentCompanyCode }}</span>
        </el-col>
        <el-col :md="12" :lg="8" :xl="6">
          Parent Company Name:
          <span class="value">{{ detail.parentCompanyName }}</span>
        </el-col>
        <el-col :md="12" :lg="8" :xl="6">
          Group Credit Line:
          <span class="value">{{ detail.amount }}</span>
        </el-col>
        <el-col :md="12" :lg="8" :xl="6">
          Group Due Date:
          <span class="value">{{ detail.dueDate }}</span>
        </el-col>
        <el-col :md="12" :lg="8" :xl="6">
          Group Buffer:
          <span class="value">{{ detail.groupBuffer }}</span>
        </el-col>
      </el-row>
      <el-divider />
      <el-row :gutter="40">
        <el-form
          ref="submitForm"
          label-width="140px"
          size="small"
          label-suffix=":"
          :model="submitForm"
          :rules="rules"
        >
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="Assigned From #" prop="assignedFromId">
              <el-select
                v-model="submitForm.assignedFromId"
                @change="_getBufferValue"
              >
                <el-option
                  v-for="item in assignedFromList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="Buffer">{{ buffer }}</el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="Assigned To#" prop="assignedToId">
              <el-select v-model="submitForm.assignedToId">
                <el-option
                  v-for="item in assignedToIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="Amount（USD）" prop="amount">
              <el-input v-model="submitForm.amount" />
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="Credit Category" prop="type">
              <el-select v-model="submitForm.type" @change="_getBufferValue">
                <el-option label="BAU" :value="1" />
                <el-option label="Uplift" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="Due Date" prop="dueDate">
              <el-date-picker
                valueFormat="yyyy-MM-dd"
                format="yyyy-MM-dd"
                style="width: 100%"
                v-model="submitForm.dueDate"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div class="btn-wrapper">
        <customize-button
          type="primary"
          style="width: 200px"
          @click="handleClickSubmitBtn"
          :loading="isLoading"
        >
          Submit
        </customize-button>
      </div>
    </template>
  </el-card>
</template>

<script>
import {
  screeningParentCompany,
  getData,
  getBufferValue,
  submitForm,
} from './api'
export default {
  data() {
    return {
      form: { parentId: '' },
      parentCompanyList: [],
      loading: false,
      isLoading: false,
      detail: {},
      submitForm: {
        assignedFromId: '',
        assignedToId: '',
        amount: '',
        type: 1,
        dueDate: '',
      },
      rules: {
        assignedFromId: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        assignedToId: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        dueDate: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        type: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        amount: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
      },
      assignedFromList: [],
      assignedToIdList: [],
      buffer: '',
    }
  },
  methods: {
    async handleClickSubmitBtn() {
      try {
        this.isLoading = true
        this.submitForm.amount = this.$utils.resetAmount(this.submitForm.amount)
        const submitData = { ...this.submitForm, ...this.form }
        await submitForm(submitData)
        this.$message.success('success')
        this.isLoading = false
        this.$refs.submitForm.resetFields()
        this.parentCompanyList = []
        this.form.parentId = ''
        this.buffer = ''
        this.detail = {}
        await this.$router.push('/business-hierarchy/group-record-management')
      } catch (e) {
        console.error(e)
        this.isLoading = false
      }
    },
    async _getBufferValue() {
      try {
        this.buffer = ''
        this.buffer = await getBufferValue({
          assignedFromId: this.submitForm.assignedFromId,
          parentId: this.form.parentId,
          type: this.submitForm.type,
        })
        this.buffer = this.$utils.formatAmount(this.buffer)
      } catch (e) {
        console.error(e)
      }
    },
    async handleClickSearchBtn() {
      try {
        this.detail = await getData({ parentId: this.form.parentId })
        this.detail.amount = this.$utils.formatAmount(this.detail.amount)
        this.detail.groupBuffer = this.$utils.formatAmount(
          this.detail.groupBuffer,
        )
        this.assignedFromList = this.detail.assignedFromList
        this.assignedToIdList = this.detail.assignedToList
        this.submitForm.dueDate = this.detail.dueDate
      } catch (e) {
        console.log(e)
      }
    },
    async remoteMethod(name) {
      if (name !== '') {
        this.loading = true
        this.parentCompanyList = await screeningParentCompany(name)
        this.loading = false
      } else {
        this.parentCompanyList = []
      }
    },
  },
}
</script>

<style scoped lang="scss">
.el-col {
  line-height: 40px;
  font-size: 15px;
}
.value {
  font-size: 14px;
  color: #5b5959;
  margin-left: 10px;
}
.el-select {
  width: 100%;
}
.btn-wrapper {
  margin: 40px 0 20px;
  text-align: center;
}
</style>
